import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { useAppState } from "../../context";
import PopularVideoStories from "../../blocks/pupular-video-stories";
import OrderRow from "../account/orders/order-row";
import { OrderType } from "../../types";

export const CheckoutSuccessPage = () => {
    const [orders] = useAppState<OrderType[]>('orders', []);

    const navigate = useNavigate();
    const { orderId } = useParams();
    const [expanded, setExpanded] = useState(true);


    useEffect(() => {
        if (!orders.length) {
            navigate('/account/cart');
        }
    }, [orders]);


    const order = orders.find(order => order.id === Number(orderId));
    if (!order) {
        return null;
    }

    return (
        <>
            <section className="section">
                <div className="inside-wrapper">
                    <ol className="ordersteps">
                        <li className="ordersteps__step m-ok">Upload your photos</li>
                        <li className="ordersteps__step m-ok">Make a payment</li>
                        <li className="ordersteps__step m-ok">Download your video</li>
                    </ol>

                    <h1 className="section__title">
                        {order.paid ? 'The payment was successful' : 'The payment was not successful'}
                    </h1>

                    <OrderRow order={order} expanded={expanded} setExpanded={setExpanded} />
                </div>
            </section>
            <PopularVideoStories />
        </>
    );
}

export default CheckoutSuccessPage;